import { useState } from 'react';
import FullModal from '../components/FullModal';
import PageTitle from '../components/PageTitle';
import Loader from '../components/Loader';

const ResetPasswordRequest = () => {
    const [inputData, setInputData] = useState('')
    const handleInputData = (event) => {
        const { value } = event.target;
        setInputData(value);
    }
    const [fetchStatus, setFetchStatus] = useState('idle');
    const [error, setError] = useState(null);
    const sendRequest = async () => {
        setFetchStatus('loading');
        const url = `${process.env.REACT_APP_SERVER_BASE_URL}/users/reset-password-request`;
        console.log('url: ', url);
        const headers = { 'Content-Type': 'application/json' };
        const options = { method: 'POST', headers, body: JSON.stringify({ email: inputData }) };
        try {
            const response = await fetch(url, options);
            if (response.ok) {
                const result = await response.json();
                console.log('result: ', result);
                setFetchStatus('succeeded');
            } else {
                const error = await response.json();
                setError(error.message);
                console.log('Fetch error: ', error);
                setFetchStatus('failed');
            }
        } catch (error) {
            setError(error.message);
            console.log('Catch error: ', error)
            setFetchStatus('failed')
        }
    }
    return (
        <FullModal px="4" items="center">

            <PageTitle backLink="/" title="Reset password" />


            {
                fetchStatus === 'idle' &&
                <div className="flex flex-col items-center gap-2 w-full">
                    <label htmlFor="email">Inserisci la tua mail:</label>
                    <input type="text" id="email" className="w-full md:w-96" onChange={handleInputData} value={inputData} />
                    <h5 className='text-center'>Ti verrà inviato un link per impostare una nuova password</h5>
                </div>
            }

            <div className='my-8'>
                {
                    fetchStatus === 'idle' &&
                    <button className='bg-[#225424] py-2 px-3 rounded-xl text-white w-full lg:w-fit' onClick={sendRequest}>Mandami l'email</button>
                }
                {
                    fetchStatus === 'loading' &&
                    <Loader />
                }
                {
                    fetchStatus === 'failed' && error &&
                    <div className="flex flex-col items-center">
                        <h3>Qualcosa è andato storto. Ricarica la pagina e riprova</h3>
                        {<h5>{error}</h5>}
                    </div>
                }
                {
                    fetchStatus === 'succeeded' &&
                    <h3 className="text-center">Se l'indirizzo è corretto, ti è stata inviata un'email con le istruzioni per il reset della password.</h3>
                }
            </div>

        </FullModal>
    )
}

export default ResetPasswordRequest;